import { render } from "./room-qty-error.vue?vue&type=template&id=10c2e56d"
const script = {}

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__